import React, { useRef, useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Avatar,
  Box,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Popover,
  Icon,
  SvgIcon,
  Tooltip,
  Typography,
  makeStyles,
  ListItemIcon
} from '@material-ui/core';
import Label from 'src/components/Label';
import {
  Bell as BellIcon,
  Circle as CircleIcon,
  Package as PackageIcon,
  MessageCircle as MessageIcon,
  Truck as TruckIcon,
  AlertCircle as alert,
  Info as info,
  Award as award
} from 'react-feather';
import { useDispatch, useSelector } from 'src/store';
import { getNotifications } from 'src/slices/notification';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { useTranslation } from 'react-i18next';
import Badge from '@material-ui/core/Badge';

// const iconsMap = {
//   1: award,
//   2: info,
//   3: alert
// };

const useStyles = makeStyles(theme => ({
  popover: {
    width: 320
  },
  icon: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText
  }
}));

const Notifications = () => {
  const classes = useStyles();
  const { notifications } = useSelector(state => state.notifications);
  const ref = useRef(null);
  const dispatch = useDispatch();
  const [isOpen, setOpen] = useState(false);
  const { t } = useTranslation();

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    dispatch(getNotifications(1, 1, ''));
  }, [dispatch]);

  const getLabel = index => {
    const map = {
      1: {
        text: 'ToDo',
        color: 'success'
      },
      2: {
        text: 'Warning',
        color: 'warning'
      },
      3: {
        text: 'Urgent',
        color: 'error'
      }
    };

    const { text, color } = map[index];

    return <Label color={color}>{text}</Label>;
  };

  const warningIcon = (
    <SvgIcon>
      <FiberManualRecordIcon style={{ color: 'orange', marginTop: '3px' }} />
    </SvgIcon>
  );
  const errorIcon = (
    <SvgIcon>
      <FiberManualRecordIcon style={{ color: 'red', marginTop: '3px' }} />
    </SvgIcon>
  );
  const goodIcon = (
    <SvgIcon>
      <FiberManualRecordIcon style={{ color: 'green ', marginTop: '3px' }} />
    </SvgIcon>
  );

  const getIndexIcon = (index, state) => {
    let icon;
    if (state !== 9) {
      switch (index) {
        case 1:
          icon = goodIcon;
          break;
        case 2:
          icon = warningIcon;
          break;
        case 3:
          icon = errorIcon;
          break;
        default:
          icon = goodIcon;
      }
    } else {
      return 'Chiusa';
    }
    return icon;
  };

  return (
    <>
      <Tooltip title={t('notifiche')}>
        <IconButton color="inherit" ref={ref} onClick={handleOpen}>
          <Badge
            badgeContent={notifications ? notifications.length : 0}
            color="error"
          >
            <SvgIcon>
              <BellIcon />
            </SvgIcon>
          </Badge>
        </IconButton>
      </Tooltip>
      <Popover
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        classes={{ paper: classes.popover }}
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
      >
        <Box p={2}>
          <Typography variant="h5" color="textPrimary">
            {t('notifiche')}
          </Typography>
        </Box>
        {!notifications || notifications.length === 0 ? (
          <Box p={2}>
            <Typography variant="h6" color="textPrimary">
              {t('noNotifications')}
            </Typography>
          </Box>
        ) : (
          <>
            <List disablePadding>
              {notifications.map(notification => {
                // const Icon = iconsMap[notification.index];

                return (
                  <ListItem
                    component={RouterLink}
                    divider
                    key={notification.id}
                    to={
                      '/app/procesdetail/' +
                      notification.proc +
                      '/' +
                      notification.step +
                      '/' +
                      notification.id +
                      ''
                    }
                  >
                    {/* <ListItemAvatar>
                      <Avatar
                        className={classes.icon}
                      >
                        <SvgIcon fontSize="small">
                          <Icon />
                        </SvgIcon>
                      </Avatar>
                      {getLabel(notification.index)}
                    </ListItemAvatar> */}

                    <ListItemIcon>
                      {getIndexIcon(notification.index, 1)}
                    </ListItemIcon>

                    <ListItemText
                      primary={notification.permission}
                      primaryTypographyProps={{
                        variant: 'subtitle2',
                        color: 'textPrimary'
                      }}
                      secondary={notification.description}
                    />
                  </ListItem>
                );
              })}
            </List>
            {/* <Box
              p={1}
              display="flex"
              justifyContent="center"
            >
              <Button
                component={RouterLink}
                size="small"
                to="#"
              >
                Mark all as read
              </Button>
            </Box> */}
          </>
        )}
      </Popover>
    </>
  );
};

export default Notifications;
